'use strict'

// todo: Unify for other possible modals *
function storeIsClosedPopup() {
  const wrapper = document.querySelector('html:not(.shopify-design-mode) .modal-wrapper.at-hidden[data-role="store-is-closed"]');
  // console.log('wrapper store-is-closed', wrapper);
  if (!wrapper) return;

  const CLOSE_BTN_HTML = `<span class="svg-wrapper close-btn">
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 2L2 12M12 12L2 2" stroke="currentColor" stroke-width="var(--icon-stroke-width)" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </span>`;

  const doc = document.documentElement;

  const container = wrapper.querySelector('[data-role="modal-container"]');

  container?.insertAdjacentHTML('afterbegin', CLOSE_BTN_HTML);

  const closeBtn = wrapper.querySelector('.close-btn');

  const HIDDEN_CLASS = 'at-hidden';
  const OVERFLOW_CLASS = 'no-scroll';
  const TIMEOUT = 3000;

  const hideModal = () => {
    wrapper.classList.add(HIDDEN_CLASS);
    doc.classList.remove(OVERFLOW_CLASS);
  }

  function displayConditions() {
    const monthSource = wrapper.querySelector('[data-role="month"]');
    const daySource = wrapper.querySelector('[data-role="day"]');

    const fixedMonth = monthSource?.textContent.trim() ?? null;
    const fixedDay = daySource?.textContent.trim() ?? null;

    if (!fixedMonth || !fixedDay || !fixedMonth === '' || !fixedDay === '') return;

    const executionDate = {
      day: parseInt(fixedDay),
      month: parseInt(fixedMonth)
    }
    console.log('executionDate', executionDate);

    const now = new Date();

    const day = now.getDate();
    const today = new Date().toISOString().split('T')[0];
    // console.log('today', today)

    const setMonth = document.getElementById('setMonth');
    const setDay = document.getElementById('setDay');

    function getLocalDateDDMMYYYY(month, day) {
      const now = new Date();
      day = String(now.getDate()).padStart(2, '0');
      month = String(now.getMonth() + 1).padStart(2, '0');
      const year = now.getFullYear();
      return { month, day }
    }
    // console.log(parseInt(getLocalDateDDMMYYYY().month), parseInt(getLocalDateDDMMYYYY().day));

    function getDateObjectInTimeZone(timeZone) {
      try {
        if (typeof timeZone !== 'string' || !timeZone.trim()) {
          throw new Error("Timezone must be a non-empty string, for example 'Europe/Vienna'");
        }

        const formatter = new Intl.DateTimeFormat('de', {
          timeZone,
          day: '2-digit',
          month: '2-digit',
          year: 'numeric'
        });

        const formatted = formatter.format(new Date());
        const [day, month, year] = formatted.split('.');

        return {
          day: Number(day),
          month: Number(month),
          year: Number(year)
        };
      } catch (error) {
        return { error: error.message };
      }
    }

    console.log("Vienna:", getDateObjectInTimeZone("Europe/Vienna"));

    function comparison() {
      const cmr = executionDate.month === parseInt(getDateObjectInTimeZone("Europe/Vienna").month) && executionDate.day === parseInt(getDateObjectInTimeZone("Europe/Vienna").day);
      return cmr;
    }

    const compare = comparison();

    if (compare === true) {
      console.log("Message On")
      setTimeout(() => {
        wrapper.classList.remove(HIDDEN_CLASS);
        doc.classList.add(OVERFLOW_CLASS);
      }, TIMEOUT);
    }
  }
  displayConditions();

  closeBtn?.addEventListener('click', hideModal);

  window.addEventListener('click', ({ target }) => {
    if (target === wrapper) hideModal();
  });

}
['DOMContentLoaded', 'shopify:section:load'].forEach(event =>
  document.addEventListener(event, storeIsClosedPopup)
);